import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import React from 'react';
import { Route } from 'react-router-dom';
import { SiteDetailsPage } from './components/SiteDetailsPage';

export function SiteDetailsRouter() {
  return (
    <RoutesWith404>
      <Route index element={<SiteDetailsPage />} />
    </RoutesWith404>
  );
}
